import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import {useNavigate} from "react-router-dom"

function Game() {
  document.title="HR Game"
    const navigate= useNavigate()
    const tiktak =()=>{
        navigate("/tiktaktoe")
    }
    const plusgame =()=>{
        navigate("/mathgame")
    }
    const Quiz =()=>{
        navigate("/indiaquiz")
    }
    const Worldquiz =()=>{
        navigate("/worldquiz")
    }
  return (
    <div>
      <div>
        <Header />
        {/* custom menu */}
        {/* do section */}
        <section className="do_section layout_padding">
          <div className="container">
            <div className="custom_heading-container">
              <h2>Start Game</h2>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-6">
                <div className="content-box bg-red">
                  <div className="img-box">
                    <img
                      src="https://media.geeksforgeeks.org/wp-content/cdn-uploads/implementation-tic-tac-toe.png"
                      alt
                    />
                  </div>
                  <div className="detail-box">
                    <h6>Tic Tac Toe</h6>
                    <p>
                      <button
                        onClick={tiktak}
                        style={{
                          width: "160px",
                          height: "40px",
                          borderRadius: "80px",
                        }}
                      >
                        Start Game
                      </button>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="content-box bg-green">
                  <div className="img-box">
                    <img
                      src="https://play-lh.googleusercontent.com/-sQLnj5dYRB3kjK2TmJoO8IcDHc40QhY23zt5-4g74aySC_uo_lDCfEUkg8A9rgyKzG-=w240-h480-rw"
                      alt
                    />
                  </div>
                  <div className="detail-box">
                    <h6>Math Game</h6>
                    <p>
                      <button
                      onClick={plusgame}
                        style={{
                          width: "160px",
                          height: "40px",
                          borderRadius: "80px",
                        }}
                      >
                        Start Game
                      </button>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="content-box bg-red">
                  <div className="img-box">
                    <img
                      src="https://play-lh.googleusercontent.com/MRM3BZUTg7sOulM1Muyk9jHgTQrwwetmztkElgy2nB1bdqogIzSHOjumpxovdNnldrQ=w240-h480-rw"
                      alt
                    />
                  </div>
                  <div className="detail-box">
                    <h6>India GK</h6>
                    <p>
                      <button
                      onClick={Quiz}
                        style={{
                          width: "160px",
                          height: "40px",
                          borderRadius: "80px",
                        }}
                      >
                        Start Game
                      </button>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="content-box bg-green">
                  <div className="img-box">
                    <img
                      src="https://play-lh.googleusercontent.com/M3rjOkMsgq8NYtrJPm54vlIOCB6uq4Zrf6blP4YdZf_nXRpFUmIJiqW68OEiuq4SIqE=w240-h480-rw"
                      alt
                    />
                  </div>
                  <div className="detail-box">
                    <h6>World GK</h6>
                    <p>
                      <button
                      onClick={Worldquiz}
                        style={{
                          width: "160px",
                          height: "40px",
                          borderRadius: "80px",
                        }}
                      >
                        Start Game
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* end do section */}
        {/* skill section */}
        <section className="skill_section layout_padding2">
          <div className="container">
            <div className="custom_heading-container">
              <h2>Improve Skills</h2>
            </div>
            <div className="skill_padding">
              <div className="row">
                <div className="col-md-3 col-sm-6">
                  <div className="box">
                    <div className="circle" id="circles-1" />
                    <h6>Flexibility</h6>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="box">
                    <div className="circle" id="circles-2" />
                    <h6>Multi-Tasking</h6>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="box">
                    <div className="circle" id="circles-3" />
                    <h6>Patience</h6>
                  </div>
                </div>
                <div className="col-md-3 col-sm-6">
                  <div className="box">
                    <div className="circle" id="circles-4" />
                    <h6>Problem Solving</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* end skill section */}
        {/* info section */}
        <Footer />
        {/* end info_section */}
        {/* footer section */}
        {/* <footer className="container-fluid footer_section">
    <p>
      © 2019 All Rights Reserved By
      <a href="https://html.design/">Free Html Templates</a>
    </p>
  </footer> */}
      </div>
    </div>
  );
}

export default Game;
